// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

ion-header {
  display: none;
  box-shadow: none;
}
@media (min-width: 991px) {
  ion-header {
    display: block;
  }
}

@media (max-width: 992px) {
  ion-content {
    position: relative;
    background: var(--ion-color-black);
  }
}
ion-content .main-block {
  flex-direction: column;
  width: 100%;
  padding: 0 5vw;
  position: absolute;
  display: flex;
  bottom: 2vh;
}
@media (min-width: 991px) {
  ion-content .main-block {
    display: none;
  }
}

.main-button {
  width: 100%;
}

.main-desktop {
  display: flex;
  justify-content: space-between;
  background: var(--ion-color-black);
  align-items: center;
  width: 100%;
  height: 100%;
}
@media (max-width: 992px) {
  .main-desktop {
    display: none;
  }
}
.main-desktop .left-block,
.main-desktop .right-block {
  width: 50%;
}
.main-desktop .left-block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.main-desktop .left-block swiper-container {
  height: 500px;
}
.main-desktop .left-block .top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
}
.main-desktop .left-block .top .main-button {
  min-width: 150px;
  width: 100%;
  max-width: 310px;
  margin: 0 auto 17%;
}
.main-desktop .left-block .top .auth-info {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 21.6px;
  letter-spacing: 0.08em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 4.1%;
}
.main-desktop .left-block .top .auth-button {
  min-height: 54px;
  min-width: 218px;
  font-size: 20px;
  line-height: 23.2px;
  letter-spacing: 0.02em;
}
.main-desktop .left-block .full-height {
  height: 100%;
}
.main-desktop .left-block .bottom {
  height: 45%;
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.main-desktop .left-block .bottom h4 {
  text-transform: uppercase;
  padding-left: 20px;
}
.main-desktop .left-block .bottom swiper-container {
  width: 100%;
  height: calc(100% - 24px);
  padding-block: 12px;
}
.main-desktop .right-block {
  height: 100%;
  display: flex;
}

.footer-wrapper {
  height: 72px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #272727;
  background: #ebdfda;
}
.footer-wrapper .auth-info {
  font-family: AppFontMedium;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 8%;
  text-transform: uppercase;
}
.footer-wrapper ion-button {
  min-height: 40px;
  font-size: 12px;
}

.title {
  margin-bottom: 15px;
  text-align: start;
  text-transform: uppercase;
}

.logo {
  height: 50dvh;
  width: auto;
  margin: 0 auto 5vh;
}
@media (min-width: 991px) {
  .logo {
    margin: auto;
    height: auto;
    width: 80%;
    max-width: 350px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.kaisin.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,sBAAA;AAAD;;AAIA;EACC,aAAA;EACA,gBAAA;AADD;ACNE;EDKF;IAIE,cAAA;EACA;AACF;;ACLE;EDQF;IAEE,kBAAA;IACA,kCAAA;EAAA;AACF;AAEC;EACC,sBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAAF;AC1BE;EDoBD;IAQE,aAAA;EAED;AACF;;AAEA;EACC,WAAA;AACD;;AAGA;EAKC,aAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAJD;ACtCE;EDgCF;IAEE,aAAA;EAQA;AACF;AAAC;;EAEC,UAAA;AAEF;AACC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACC,aAAA;AACH;AAEE;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;AADH;AAGG;EACC,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGG;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AADJ;AAKG;EACC,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAHJ;AAOE;EACC,YAAA;AALH;AAQE;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AANH;AAOG;EACC,yBAAA;EACA,kBAAA;AALJ;AAOG;EACC,WAAA;EACA,yBAAA;EACA,mBAAA;AALJ;AAoBC;EACC,YAAA;EACA,aAAA;AAlBF;;AAuBA;EACC,YAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,6BAAA;EACA,mBAAA;AArBD;AAuBC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AArBF;AAwBC;EACC,gBAAA;EACA,eAAA;AAtBF;;AA0BA;EACC,mBAAA;EACA,iBAAA;EACA,yBAAA;AAvBD;;AA0BA;EACC,aAAA;EACA,WAAA;EACA,kBAAA;AAvBD;ACpJE;EDwKF;IAKE,YAAA;IACA,YAAA;IACA,UAAA;IACA,gBAAA;EArBA;AACF","sourcesContent":["@import '../../../theme/mixins';\n* {\n\tbox-sizing: border-box;\n}\n\n\nion-header {\n\tdisplay: none;\n\tbox-shadow: none;\n\t@include desktop {\n\t\tdisplay: block;\n\t}\n}\n\n\nion-content {\n\t@include mobile {\n\t\tposition: relative;\n\t\tbackground: var(--ion-color-black);\n\t}\n\n\t.main-block {\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tpadding: 0 5vw;\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\tbottom: 2vh;\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n.main-button {\n\twidth: 100%;\n}\n\n\n.main-desktop {\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tbackground: var(--ion-color-black);\n\talign-items: center;\n\twidth: 100%;\n\theight: 100%;\n\t.left-block,\n\t.right-block {\n\t\twidth: 50%;\n\t}\n\n\t.left-block {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tswiper-container {\n\t\t\theight: 500px;\n\t\t}\n\n\t\t.top {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\tpadding: 50px;\n\n\t\t\t.main-button {\n\t\t\t\tmin-width: 150px;\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 310px;\n\t\t\t\tmargin: 0 auto 17%;\n\t\t\t}\n\t\t\t.auth-info {\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 21.6px;\n\t\t\t\tletter-spacing: 0.08em;\n\t\t\t\ttext-align: center;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tmargin-bottom: 4.1%;\n\t\t\t\t\n\t\t\t}\n\n\t\t\t.auth-button {\n\t\t\t\tmin-height: 54px;\n\t\t\t\tmin-width: 218px;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 23.2px;\n\t\t\t\tletter-spacing: 0.02em;\n\t\t\t}\n\t\t}\n\n\t\t.full-height {\n\t\t\theight: 100%;\n\t\t}\n\n\t\t.bottom {\n\t\t\theight: 45%;\n\t\t\twidth: 100%;\n\t\t\toverflow: auto;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\th4 {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tpadding-left: 20px;\n\t\t\t}\n\t\t\tswiper-container {\n\t\t\t\twidth: calc(100%);\n\t\t\t\theight: calc(100% - 24px);\n\t\t\t\tpadding-block: 12px;\n\n\t\t\t\t::ng-deep swiper-slide {\n\t\t\t\t\t// div {\n\t\t\t\t\t// \twidth: 100%;\n\t\t\t\t\t// \theight: 100%;\n\t\t\t\t\t// }\n\t\t\t\t\t// .item-container {\n\t\t\t\t\t// \toverflow: auto;\n\t\t\t\t\t// }\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.right-block {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t}\n}\n\n\n.footer-wrapper {\n\theight: 72px;\n\tpadding: 20px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tborder-top: 1px solid #272727;\n\tbackground: #ebdfda;\n\n\t.auth-info {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 10px;\n\t\tline-height: 12px;\n\t\tletter-spacing: 8%;\n\t\ttext-transform: uppercase;\n\t}\n\n\tion-button {\n\t\tmin-height: 40px;\n\t\tfont-size: 12px;\n\t}\n}\n\n.title {\n\tmargin-bottom: 15px;\n\ttext-align: start;\n\ttext-transform: uppercase;\n}\n\n.logo {\n\theight: 50dvh;\n\twidth: auto;\n\tmargin: 0 auto 5vh;\n\t@include desktop {\n\t\tmargin: auto;\n\t\theight: auto;\n\t\twidth: 80%;\n\t\tmax-width: 350px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
